module.exports = __webpack_public_path__ + "img/malaysia.1a33f304.png";